import { motion } from "framer-motion";
import StatusBadge from "./StatusBadge";
import SoldTape from "./SoldTape";
import TapInButton from "./TapInButton";

export default function DropCard({ drop, index = 0 }) {
  const sold = drop.status === "SOLD_OUT";
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: (index % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
      data-testid={`drop-card-${index}`}
      className={`group flex flex-col border border-yaza-border bg-yaza-surface ${sold ? "opacity-40" : ""}`}
    >
      <div className="relative aspect-square overflow-hidden bg-yaza-surface2">
        {drop.photos?.[0] && (
          <img
            src={drop.photos[0]}
            alt={drop.title}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
        )}
        {sold && <SoldTape testid={`drop-sold-tape-${index}`} />}
        <div className="absolute left-3 top-3">
          <StatusBadge status={drop.status} />
        </div>
      </div>
      <div className="flex flex-1 flex-col p-5">
        <div className="flex items-start justify-between gap-3">
          <h3 className="font-display text-2xl leading-none tracking-wide">{drop.title}</h3>
          {drop.price && <span className="text-sm text-yaza-accent">{drop.price}</span>}
        </div>
        {drop.description && <p className="mt-3 flex-1 text-sm text-yaza-dim">{drop.description}</p>}
        <div className="mt-6">
          {sold ? (
            <span className="inline-block border border-yaza-grey px-6 py-3 font-mono text-xs font-bold uppercase tracking-[0.2em] text-yaza-grey">
              Sold Out
            </span>
          ) : (
            <TapInButton context={`the ${drop.title} drop`} testid={`drop-tapin-${index}`} />
          )}
        </div>
      </div>
    </motion.div>
  );
}
